import React, { Component } from "react"
import ReactEcharts from "echarts-for-react"

class VesselTypesCategoryChart extends Component<any> {
    Chart = () => {
        let Vessels: any[];
        this.props.graphData?.map((item: any) => { return Vessels?.push(item.vessel_type) })
        return {
            color: ['#058742', '#8bc63e', '#f7ee21', '#fbb03f', '#f3786e'],
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
                }
            },
            legend: {},
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: {
                type: 'value'
            },
            yAxis: {
                type: 'category',
                data: this.props.graphData?.map((item: any) => { return (item.vessel_type) })
            },
            series: [
                {
                    name: 'A',
                    type: 'bar',
                    stack: 'total',
                    label: {
                        show: true
                    },
                    emphasis: {
                        focus: 'series'
                    },
                    data: this.props.graphData?.map((item: any) => { return item.a })
                },
                {
                    name: 'B',
                    type: 'bar',
                    stack: 'total',
                    label: {
                        show: true
                    },
                    emphasis: {
                        focus: 'series'
                    },
                    data: this.props.graphData?.map((item: any) => { return item.b })
                },
                {
                    name: 'C',
                    type: 'bar',
                    stack: 'total',
                    label: {
                        show: true
                    },
                    emphasis: {
                        focus: 'series'
                    },
                    data: this.props.graphData?.map((item: any) => { return item.c })
                },
                {
                    name: 'D',
                    type: 'bar',
                    stack: 'total',
                    label: {
                        show: true
                    },
                    emphasis: {
                        focus: 'series'
                    },
                    data: this.props.graphData?.map((item: any) => { return item.d })
                },
                {
                    name: 'E',
                    type: 'bar',
                    stack: 'total',
                    label: {
                        show: true
                    },
                    emphasis: {
                        focus: 'series'
                    },
                    data: this.props.graphData?.map((item: any) => { return item.e })
                }
            ]
        }
    }
    render() {
        return (
            <>
                <h6 className="text-center">No. of vessel types according to CII category</h6>
                <ReactEcharts style={{ height: "350px" }} option={this.Chart()} />
            </>
        )
    }
}

export default VesselTypesCategoryChart;